<template>
  <div class="container-fluid d-flex flex-column">
    <h4 class="d-flex mt-3">
      Telkom Fantasy Football – Terms &amp; Conditions
    </h4>

    <!-- Notices A–F -->
    <div class="d-flex mt-3"><b>NOTE</b></div>
    <div class="d-flex px-2">A. These Terms and Conditions contain assumptions of risk and/or liability by Customers and limit and exclude liabilities, obligations and legal responsibilities which Telkom SA SOC Limited (“Telkom”) will have towards Customers and other persons.</div>
    <div class="d-flex px-2">B. These Terms and Conditions also limit and exclude Customers’ rights and remedies against Telkom and place various risks, liabilities, obligations and legal responsibilities on the Customer.</div>
    <div class="d-flex px-2">C. These Terms and Conditions may result in Customers being responsible for paying additional costs and amounts, and Telkom may also have claims and other rights against the Customer.</div>
    <div class="d-flex px-2">D. To the extent that these Terms and Conditions or any goods or services provided under them are governed by the Consumer Protection Act, 2008 (“CPA”), no provision is intended to contravene its applicable provisions. All provisions must be treated as qualified, to the extent necessary, to ensure compliance with the CPA.</div>
    <div class="d-flex px-2">E. Customers must read these Terms and Conditions carefully. Use of this product/service will constitute agreement to comply.</div>
    <div class="d-flex px-2">F. These Terms and Conditions must be read together with the standard Telkom Internet product and service Terms and Conditions and the Penrose Systems Privacy Notice (see item 11).</div>

    <!-- 1. Introduction -->
    <div class="d-flex mt-3"><b>1. Introduction</b></div>
    <div class="d-flex px-2">
      1.1 Telkom customers who subscribe to the Fantasy Football service gain access to the world’s football games and are bound by the following rules.
    </div>
    <div class="d-flex px-3">
      <span class="me-2">GENERAL:</span>
      Fantasy Football is a premium mobile-based service in South Africa where users assemble imaginary teams of real-life athletes and score points based on actual performance. Access is paid via a recurring daily subscription; users can build teams and compete in leagues and may win prizes.
    </div>
    <div class="d-flex px-2">
      1.2 Pricing: R7.00 per day, or a lesser promotional amount. Pricing may vary by Telkom or Penrose Systems adjustments.
    </div>

    <!-- 2. Duration -->
    <div class="d-flex mt-3"><b>2. Duration</b></div>
    <div class="d-flex px-2">2.1 Available from 1 October 2025 until Telkom terminates in its discretion.</div>
    <div class="d-flex px-2">2.2 Telkom may amend duration (shorter/longer) or withdraw with notice.</div>
    <div class="d-flex px-2">2.3 Visit <a href="https://telkomplus.co.za" target="_blank" rel="noopener">telkomplus.co.za</a> or dial *180# for updates.</div>

    <!-- 3. Eligibility -->
    <div class="d-flex mt-3"><b>3. Who is Eligible?</b></div>
    <div class="d-flex px-2">3.1 To participate, you must:</div>
    <div class="d-flex px-3">3.1.1 Be a South African citizen; 3.1.2 Reside in South Africa; 3.1.3 Be a natural person; 3.1.4 Be 18+; 3.1.5 Be a Telkom subscriber (Prepaid/Hybrid/Contract); 3.1.6 Subscribe and participate via USSD, mobile site, or other Telkom channels.</div>

    <!-- 4. Game Rules -->
    <div class="d-flex mt-3"><b>4. Fantasy Football Predictor Game Rules</b></div>
    <div class="d-flex px-2">1) Each fantasy line-up must include real athletes from at least one real-life match.</div>
    <div class="d-flex px-2">2) Winning cannot be based solely on the single performance of one athlete.</div>
    <div class="d-flex px-2">3) The Service prevents saving an invalid line-up.</div>
    <div class="d-flex px-2">4) No trading, extra moves, or replacing injured/benched players. Each event requires: one striker, two midfielders, one defensive unit (players listed as defensive by the stats provider) and a goalkeeper.</div>
    <div class="d-flex px-2">5) Player pool is defined by the Statistics Provider for eligible matches.</div>
    <div class="d-flex px-2">6) “Missing” players are added only once recognised by the Statistics Provider.</div>
    <div class="d-flex px-2">7) After the specified cutoff, entries may not be added/edited/cancelled.</div>
    <div class="d-flex px-2">8) Results and winners are based on total points across the entrant’s squad for the event duration.</div>
    <div class="d-flex px-2">9) If a match is rescheduled outside the original event window, players from that match score zero.</div>
    <div class="d-flex px-2">9. (USSD) Answering both questions correctly doubles the session’s coin earnings; incorrect answers halve them.</div>

    <!-- 5. Prizes and Points -->
    <div class="d-flex mt-3"><b>5. Prizes and Points</b></div>
    <div class="d-flex px-2">5.1 Prizes/rewards are determined by coins earned and engagement; predictions do not guarantee wins.</div>
    <div class="d-flex px-2">5.2 Telkom and Penrose Systems may adjust prize pools, points, and leaderboard mechanics.</div>
    <div class="d-flex px-2">5.3 Participants stand a chance to win Airtime/Data coupons:</div>

    <div class="table-responsive px-2">
      <table class="table table-sm table-bordered table-striped table-fit-screen mt-2">
        <thead>
        <tr>
          <th>Category</th>
          <th>Reward Type</th>
          <th>Frequency</th>
          <th>Eligibility</th>
          <th>Value</th>
          <th>Monthly winners</th>
          <th>Daily winners</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>Daily Participation (Engagement)</td>
          <td>Coupon</td>
          <td>Daily</td>
          <td>Premium</td>
          <td>R5.00</td>
          <td>6000</td>
          <td>200</td>
        </tr>
        <tr>
          <td>Fantasy Predictor</td>
          <td>Coupon</td>
          <td>Daily</td>
          <td>Premium</td>
          <td>R10.00</td>
          <td>3000</td>
          <td>100</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex px-2">Total Prize Value: R720,000.00 (seven hundred and twenty thousand Rand).</div>

    <div class="d-flex px-2 mt-2"><b>Coins earning structure</b></div>
    <div class="table-responsive px-2">
      <table class="table table-sm table-bordered table-striped table-fit-screen mt-2">
        <thead>
        <tr>
          <th>Activity</th>
          <th>Coins Earned</th>
        </tr>
        </thead>
        <tbody>
        <tr><td>Subscribing to the Premium Service</td><td>50</td></tr>
        <tr><td>First play on freemium service</td><td>10</td></tr>
        <tr><td>Answering each question correctly</td><td>10</td></tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex px-2">Once requirements of 4–5.3 are met, entry into the Competition is automatic.</div>

    <!-- 6. Unsubscribing -->
    <div class="d-flex mt-3"><b>6. Unsubscribing</b></div>
    <div class="d-flex px-2">6.1 Dial *179# and follow prompts to unsubscribe.</div>
    <div class="d-flex px-2">6.2 On unsubscribe, future access stops; Penrose Systems may retain profile records for regulatory/marketing purposes.</div>

    <!-- 7. RICA -->
    <div class="d-flex mt-3"><b>7. RICA</b></div>
    <div class="d-flex px-2">7.1 SIMs must be registered per the Amended RICA Act 70 of 2002.</div>
    <div class="d-flex px-2">7.2 Failure to comply may result in SIM deactivation and service impact.</div>
    <div class="d-flex px-2">7.3 Lost/stolen/damaged SIMs must be reported to SAPS and Telkom immediately.</div>
    <div class="d-flex px-2">7.4 Offers/subscriptions are non-transferable upon change of SIM ownership.</div>

    <!-- 8. Modification -->
    <div class="d-flex mt-3"><b>8. Modification of Terms</b></div>
    <div class="d-flex px-2">8.1 Telkom may change/vary/replace these Terms or Fantasy Football rules at any time.</div>
    <div class="d-flex px-2">8.2 See <a href="https://telkomplus.co.za" target="_blank" rel="noopener">telkomplus.co.za</a> for updates; continued use = acceptance.</div>
    <div class="d-flex px-2">8.3 Telkom may vary service charges at its discretion.</div>

    <!-- 9. Limitation of Liability -->
    <div class="d-flex mt-3"><b>9. Limitation of Liability</b></div>
    <div class="d-flex px-2">9.1 Subject to the CPA and applicable law.</div>
    <div class="d-flex px-2">9.2 Not liable for delayed device/SIM delivery, network interruptions, or failures to suspend upon request.</div>
    <div class="d-flex px-2">9.3 Not liable for loss caused by negligent acts of Telkom, employees, or agents, or due to device use related to this service (to the extent permitted by law).</div>
    <div class="d-flex px-2">9.4 Does not limit implied warranties where such limitation is disallowed by law.</div>

    <!-- 10. General -->
    <div class="d-flex mt-3"><b>10. General</b></div>
    <div class="d-flex px-2">10.1 Leaderboards are updated on-platform (portal/USSD).</div>
    <div class="d-flex px-2">10.2 Telkom, Penrose Systems, and their affiliates assume no liability for direct/indirect losses arising from participation.</div>
    <div class="d-flex px-2">10.3 Telkom may terminate subscriptions in cases of fraud/suspected fraud.</div>

    <!-- 11. Penrose Systems Privacy Notice -->
    <div class="d-flex mt-3"><b>11. Penrose Systems Privacy Notice</b></div>
    <div class="d-flex px-2"><u>Data we collect</u>: Your cell number and daily activity (logins, participation, scores).</div>
    <div class="d-flex px-2"><u>How we use it</u>: Fantasy Football games are games of skill; points via real athlete performance and/or predictor participation.</div>
    <div class="d-flex px-2"><u>Sharing</u>: Only with Telkom and operational providers (storage, auditing) to manage your subscription.</div>
    <div class="d-flex px-2"><u>Retention</u>: While active and up to 6 months post-cancellation for regulatory/promotional communication.</div>
    <div class="d-flex px-2"><u>Security</u>: Reasonable measures applied by Penrose Systems.</div>
    <div class="d-flex px-2"><u>Your rights</u>: Email <a href="mailto:hello@thefanclash.com">hello@thefanclash.com</a> to opt out/object/complain (up to 21 days to respond).</div>

    <!-- 12. Governing Law -->
    <div class="d-flex mt-3"><b>12. Governing Law</b></div>
    <div class="d-flex px-2">12.1 South African law governs.</div>

    <!-- 13. Contact -->
    <div class="d-flex mt-3"><b>13. Contact</b></div>
    <div class="d-flex px-2">Support: Dial 180 or email <a href="mailto:180@telkom.co.za">180@telkom.co.za</a> or <a href="mailto:hello@thefanclash.com">hello@thefanclash.com</a>.</div>
    <div class="d-flex px-2">Billing queries/disputes: email <a href="mailto:180@telkom.co.za">180@telkom.co.za</a> or call 180.</div>

    <!-- 14, 16–19 -->
    <div class="d-flex mt-3"><b>14. Billing Errors</b></div>
    <div class="d-flex px-2">If a billing error is found, Telkom/Penrose will investigate and refund due amounts to your bank account.</div>

    <div class="d-flex mt-3"><b>16–19. WASPA, Complaints, Breach, Revisions</b></div>
    <div class="d-flex px-2">16. Telkom and Penrose Systems are WASPA members and bound by the WASPA Code.</div>
    <div class="d-flex px-2">16. You may lodge a complaint with WASPA: <a href="https://www.waspa.org.za" target="_blank" rel="noopener">www.waspa.org.za</a>.</div>
    <div class="d-flex px-2">17. Telkom/Penrose may share information with WASPA for complaint resolution.</div>
    <div class="d-flex px-2">18. If you breach these terms, Telkom/Penrose may suspend access temporarily or permanently.</div>
    <div class="d-flex px-2">19. Telkom/Penrose reserve the right to revise these terms from time to time.</div>

    <!-- Return -->
    <div class="d-flex justify-content-center align-items-center mt-3 mb-5" @click="onReturnToPreviousPageClicked">
      <b><u>Return to previous page</u></b>
    </div>
  </div>
</template>

<script>
export default {
  name: "TelkomZATerms",
  methods: {
    onReturnToPreviousPageClicked() {
      this.$router.push("/profile");
    }
  }
};
</script>

<style scoped>
.table-fit-screen {
  font-size: x-small !important;
}
.return-previous {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
</style>
